export default function (_ref) {
  var store = _ref.store,
      error = _ref.error,
      redirect = _ref.redirect,
      res = _ref.res;

  if (!store.state.authUser) {
    error({
      message: 'Permission denied',
      statcusCode: 401
    });
  }
  if (store.state.authUser.roleID.toLowerCase() !== 'partner') {
    error({
      message: 'Permission denied',
      statcusCode: 401
    });
  }
}


//////////////////
// WEBPACK FOOTER
// ./middleware/authorizePartner.js
// module id = ./middleware/authorizePartner.js
// module chunks = 82